import script from "./DepartmentManagers.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentManagers.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentManagers.vue?vue&type=style&index=0&id=b3b71f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3b71f4a"]])

export default __exports__